// All available configuration fields and groups for Performance Summary
export const PerformanceSummaryFields = {
  // Show [affects field visibility]
  GROUP_ROWS: 'Rows',
  PRODUCTION: 'Production',
  CAPACITY_FACTOR: 'Capacity Factor',
  CONTRACTUAL_AVAILABILITY: 'Contractual Availability',
  AVERAGE_WIND_SPEED: 'Avg Wind Speed',
  LOST_PRODUCTION: 'Lost Production',
  OPERATING_HOURS: 'Operating Hours',
};

// Performance Summary field definitions
export const performanceFieldDefs = {
  [PerformanceSummaryFields.GROUP_ROWS]: {
    labels: [
      {
        a11yKey: 'performance.rows',
        a11yDefault: 'Rows',
      },
    ],
    fields: {
      [PerformanceSummaryFields.PRODUCTION]: {
        locked: true,
        labels: [
          {
            a11yKey: 'performance.production',
            a11yDefault: 'Production',
          },
        ],
      },
      [PerformanceSummaryFields.CAPACITY_FACTOR]: {
        labels: [
          {
            a11yKey: 'performance.capacity_factor',
            a11yDefault: 'Capacity Factor',
          },
        ],
      },
      [PerformanceSummaryFields.CONTRACTUAL_AVAILABILITY]: {
        locked: true,
        labels: [
          {
            a11yKey: 'performance.contractual_availability',
            a11yDefault: 'Contractual Availability',
          },
        ],
      },
      [PerformanceSummaryFields.AVERAGE_WIND_SPEED]: {
        labels: [
          {
            a11yKey: 'performance.avg_wind_speed',
            a11yDefault: 'Avg Wind Speed',
          },
        ],
      },
      [PerformanceSummaryFields.LOST_PRODUCTION]: {
        labels: [
          {
            a11yKey: 'performance.lost_production',
            a11yDefault: 'Lost Production',
          },
        ],
      },
    },
  },
};

// Default order and visibility configuration for Performance Summary fields
// NOTE: For state selection, EVERY field must have a position and visibility default!

export const performanceDefaultConfig = [
  // This flag tells the config loader to use the values specified here and not overwrite
  // with configuration values sent from the server.
  {
    id: PerformanceSummaryFields.GROUP_ROWS,
    // ignoreTemplateConfig: true,
    fields: [
      {
        id: PerformanceSummaryFields.PRODUCTION,
        visible: true,
      },
      {
        id: PerformanceSummaryFields.CAPACITY_FACTOR,
        visible: true,
      },
      {
        id: PerformanceSummaryFields.CONTRACTUAL_AVAILABILITY,
        visible: true,
      },
      {
        id: PerformanceSummaryFields.AVERAGE_WIND_SPEED,
        visible: true,
      },
      {
        id: PerformanceSummaryFields.LOST_PRODUCTION,
        visible: true,
      },
      {
        id: PerformanceSummaryFields.OPERATING_HOURS,
        visible: true,
      },
    ],
  },
];

export const PerformanceStateKeys = {
  CONFIG_STATE: 'configState',
};
